<template>
	<select @change='change' v-model="selected" class='form-control my-control' :class='field_class'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../constants'
	const ORGANIZATION = 'get_organization.php'

	import {EventBus} from '../../lib/EventBus'

	export default {
		name: 'regOrganization',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			set_id: '',
			field_class: '',
			id: null
		},
		methods: {
			change () {
				EventBus.$emit(`reg-organization`, this.selected)
			}
		},
		mounted () {
			fetch(DB + ORGANIZATION, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = this.$props.id ? this.$props.id : data[0].id
					this.change()
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))
		},
	}
</script>


// WEBPACK FOOTER //
// organization.vue?70275074